import { useEffect, useMemo, useState } from "react";

function formatKo(dt?: string | null) {
  if (!dt) return null;
  try {
    return new Date(dt).toLocaleString("ko-KR");
  } catch {
    return dt;
  }
}

export default function Privacy() {
  const [html, setHtml] = useState<string>("");
  const [updatedAt, setUpdatedAt] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const updatedLabel = useMemo(() => formatKo(updatedAt), [updatedAt]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        setError(null);

        const r = await fetch("/api/legal/privacy", { credentials: "include" });
        const data = await r.json();

        if (!data?.ok) throw new Error(data?.message || "로드 실패");

        setHtml(String(data?.row?.html || ""));
        setUpdatedAt(data?.row?.updated_at || null);
      } catch (e: any) {
        setError(e?.message || "로드 실패");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <main className="bg-white">
      <div className="mx-auto max-w-4xl px-4 py-10 sm:py-12">
        <header className="border-b border-slate-200 pb-5">
          <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
            개인정보처리방침
          </h1>
          {updatedLabel && (
            <p className="mt-2 text-sm text-slate-500">
              최종 업데이트: {updatedLabel}
            </p>
          )}
        </header>

        {error ? (
          <div className="mt-6 rounded-xl border border-rose-200 bg-rose-50 p-4 text-rose-700">
            {error}
          </div>
        ) : loading ? (
          <div className="mt-8 text-sm text-slate-500">불러오는 중...</div>
        ) : (
          <article className="mt-8">
            <div
              className="
                prose prose-slate max-w-none
                prose-headings:scroll-mt-24
                prose-p:leading-7
                prose-li:my-1
              "
            >
              <div
                className="break-words"
                dangerouslySetInnerHTML={{ __html: html || "<p></p>" }}
              />
            </div>
          </article>
        )}
      </div>
    </main>
  );
}
